/**
 * created by tian ruo jun
 demo
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CandidateComponents from "./CandidateComponents";
import {Button} from "antd";

export default class Demo extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div style={{display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',}}>
                <CandidateComponents ref={(ref)=>{this.CandidateComponents=ref}} />
                <Button type="primary" onClick={()=>{
                    this.CandidateComponents.getSelectList((selectList)=>{
                        console.log('selectList', selectList)
                    })
                }}>确定</Button>
            </div>
        )
    }

}